<template>
  <div class="property">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ `住戶資料 - ${householdName}` }}
          </div>
          <div class="tip">
            可在此新增 / 編輯 / 檢視住戶資料
          </div>
        </div>
      </div>

      <div class="title_bar center">
        <div class="left" />
        <div class="right">
          <el-button
            icon="icon-plus"
            :disabled="isAddingResident"
            round
            @click="addRow"
          >
            新增住戶資料
          </el-button>
        </div>
      </div>

      <el-table
        :data="presentResidentList"
        empty-text="暫無住戶資料"
        style="width: 100%"
      >
        <el-table-column
          label="#"
          type="index"
          width="50"
        />
        <el-table-column
          v-for="[key, value] of Object.entries(householdDetailStructure) "
          :key="key"
          :prop="key"
          :label="value.label"
          :width="'auto'"
          :label-class-name="key === 'ResidentName' && isAnyEditing ? 'redStar' : 'what'"
        >
          <template slot-scope="scope">
            <div
              v-if="!scope.row.isEditing"
              class="regular"
            >
              {{ scope.row[key] }}
            </div>
            <el-form
              v-else
              :ref="`form${scope.row.formId}`"
              :rules="rules"
              :model="scope.row"
              label-width="0px"
              :inline="true"
            >
              <el-form-item
                :class="key"
                :prop="key"
              >
                <el-input
                  v-if="!(key === 'IdentityName')"
                  v-model="scope.row[key]"
                  :placeholder="`${value.label}`"
                  :maxlength="value.maxLength"
                  type="textarea"
                  :autosize="true"
                  resize="none"
                  @input="onInput(key, scope.row)"
                />
                <el-select
                  v-else
                  v-model="scope.row[key]"
                  placeholder="請選擇"
                >
                  <el-option
                    v-for="item in roleOptions"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Label"
                  />
                </el-select>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :width="180"
        >
          <template slot-scope="scope">
            <div class="operate">
              <el-button
                v-if="!scope.row.isEditing"
                size="mini"
                @click="clickEditResident(scope.row)"
              >
                編輯
              </el-button>
              <el-button
                v-if="!scope.row.isEditing"
                size="mini"
                type="danger"
                plain
                @click="clickDeleteResident(scope.row, scope.$index)"
              >
                刪除
              </el-button>
              <el-button
                v-if="scope.row.isEditing"
                size="mini"
                plain
                @click="cancelEditResident(scope.row, scope.$index)"
              >
                取消
              </el-button>
              <el-button
                v-if="scope.row.isEditing"
                size="mini"
                type="primary"
                plain
                @click="submitEditResident(scope.row)"
              >
                送出
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { householdDetailStructure } from './models'
const pureNumRegex = /^[0-9]+$/
const notPureNumRegex = /[^0-9]/g
const notPlateRegex = /[^a-zA-Z0-9-; ]/g
export default {
  data () {
    const checkPlateNumber = (rule, value, callback) => {
      const plateNumberArr = value.split(';').map(el => el.trim())
      const isOverMax = plateNumberArr.some(el => el.length > 10)
      const isInvalid = plateNumberArr.some(el => el.match(/[^a-zA-Z0-9-]/))
      if (isOverMax) {
        callback(new Error('單筆車牌限 10 個字元，多筆車牌請用半形分號「;」隔開'))
      }
      if (isInvalid) {
        callback(new Error('請正確輸入車牌號碼'))
      }
      callback()
    }
    const rules = {
      ResidentName: [
        { required: true, message: '請輸入住戶名稱', trigger: 'blur' },
        { max: 10, message: '限 10 個字元', trigger: 'blur' }
      ],
      MobilePhoneNumber: [
        { pattern: /^09[0-9]{8}$/, message: '手機格式錯誤，請輸入正確電話號碼', trigger: 'blur' }
      ],
      LocalPhoneNumber: [
        { pattern: pureNumRegex, message: '請輸入數字', trigger: 'blur' },
        { max: 15, message: '限 15 個字元', trigger: 'blur' }
      ],
      EmergencyContactName: [
        { max: 10, message: '限 10 個字元', trigger: 'blur' }
      ],
      EmergencyContactPhone: [
        { pattern: /^09[0-9]{8}$/, message: '手機格式錯誤，請輸入正確電話號碼', trigger: 'blur' }
      ],
      Car: [
        { validator: checkPlateNumber, trigger: 'blur' }
      ],
      Scooter: [
        { validator: checkPlateNumber, trigger: 'blur' }
      ],
      Note: [
        { max: 50, message: '限 50 個字元', trigger: 'blur' }
      ]
    }
    const presentResidentList = []
    const roleList = []
    // const vehicleList = []
    const roleOptions = []
    const tabletId = 1605100001
    const isAddingResident = false
    const formId = 0
    const householdName = ''
    return {
      householdDetailStructure,
      presentResidentList,
      roleList,
      // vehicleList,
      roleOptions,
      tabletId,
      isAddingResident,
      rules,
      formId,
      householdName
    }
  },
  computed: {
    isAnyEditing () {
      return this.presentResidentList.some(el => el.isEditing)
    }
  },
  async mounted () {
    this.tabletId = this.$route.params.id
    try {
      const resRoles = await apiHousehold.getRoles()
      this.roleList = resRoles.data.Data.ResidentIdentitys.map(el => ({
        ...el,
        Label: el.Name
      }))
    } catch (e) {
      console.log(e)
    }
    this.roleOptions = [{
      Id: 0,
      Name: '請選擇',
      Label: ''
    }, ...this.roleList]
    // 交通工具的部分先 hardcode，目前只有汽機車兩種，若要擴展前端也要動
    // this.vehicleList = resTransportations.data.Data.Transportations
    const resResidentList = await apiHousehold.getResident(this.tabletId)
    const dataResidentList = resResidentList.data.Data.CommunityResidents
    this.householdName = resResidentList.data.Data.CommunityTabletName
    this.presentResidentList = this.responseResidentListToPresentResidentList(dataResidentList)
  },
  methods: {
    genFormId () {
      return this.formId++
    },
    identityIdToIdentityName (identityId) {
      return this.roleList.find(el => el.Id === identityId)?.Name
    },
    identityNameToIdentityId (identityName) {
      return this.roleList.find(el => el.Name === identityName)?.Id || null
    },
    addRow () {
      this.isAddingResident = true
      this.presentResidentList = [
        {
          ResidentName: '',
          IdentityName: '',
          MobilePhoneNumber: '',
          LocalPhoneNumber: '',
          EmergencyContactName: '',
          EmergencyContactPhone: '',
          Car: '',
          Scooter: '',
          Note: '',
          isEditing: true,
          formId: this.genFormId()
        },
        ...this.presentResidentList
      ]
    },
    onInput (key, row) {
      const val = row[key]
      switch (key) {
        case 'MobilePhoneNumber':
          row[key] = val.replace(notPureNumRegex, '')
          break
        case 'LocalPhoneNumber':
          row[key] = val.replace(notPureNumRegex, '')
          break
        case 'EmergencyContactPhone':
          row[key] = val.replace(notPureNumRegex, '')
          break
        case 'Car':
          row[key] = val.replace(notPlateRegex, '')
          break
        case 'Scooter':
          row[key] = val.replace(notPlateRegex, '')
          break
        default:
          break
      }
    },
    responseResidentListToPresentResidentList (data) {
      const tempData = [...data]
      tempData.forEach(el => {
        const carList = []
        const scooterList = []
        // 交通工具的部分先 hardcode，目前只有汽機車兩種，若要擴展前端也要動
        el.Transportations.forEach(vehicle => {
          switch (vehicle.TransportationsTypeId) {
            case 1:
              carList.push(vehicle.TransportationsSn)
              break
            case 2:
              scooterList.push(vehicle.TransportationsSn)
              break
            default:
              break
          }
        })
        el.Car = carList.join('; ')
        el.Scooter = scooterList.join('; ')
        el.IdentityName = this.identityIdToIdentityName(el.ResidentIdentityId)
        // 是否正在編輯此筆資料
        el.isEditing = false
        el.formId = this.genFormId()
      })
      return tempData
    },
    presentResidentDataToReqResidentData (data) {
      const { ResidentName, MobilePhoneNumber, LocalPhoneNumber, EmergencyContactName, EmergencyContactPhone, Note } = data
      const ResidentIdentityId = this.identityNameToIdentityId(data.IdentityName)
      const carList = data.Car?.split(';')?.map(el => el.trim()).filter(el => el)
      const carObjList = carList?.map(el => ({
        TransportationsTypeId: 1,
        TransportationsSn: el
      }))
      const scooterList = data.Scooter?.split(';')?.map(el => el.trim()).filter(el => el)
      const scooterObjList = scooterList?.map(el => ({
        TransportationsTypeId: 2,
        TransportationsSn: el
      }))
      const Transportations = [...carObjList, ...scooterObjList]
      const reqResidentData = {
        ResidentName,
        ResidentIdentityId,
        MobilePhoneNumber,
        LocalPhoneNumber,
        EmergencyContactName,
        EmergencyContactPhone,
        Note,
        Transportations
      }
      if (!ResidentIdentityId) {
        delete reqResidentData.ResidentIdentityId
      }
      return reqResidentData
    },
    clickEditResident (row) {
      row.snapshotData = _cloneDeep(row)
      row.isEditing = true
    },
    async clickDeleteResident (row, index) {
      const confirmText = '請確認是否刪除此資料'
      this.$confirm(confirmText, '', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await apiHousehold.deleteResident(this.tabletId, row.Id)
          this.presentResidentList.splice(index, 1)
          this.$message({
            type: 'success',
            message: '刪除成功'
          })
        } catch (error) {
          this.$message({
            type: 'error',
            message: '刪除失敗'
          })
        }
      }).catch(() => {
      })
    },
    cancelEditResident (row, index) {
      if (row.Id) {
        // 恢復原值
        Object.keys(row).forEach(key => {
          if (key !== 'snapshotData') {
            row[key] = row.snapshotData[key]
          }
        })
        // 取消編輯
        row.isEditing = false
      } else {
        this.isAddingResident = false
        this.presentResidentList.shift()
      }
    },
    async submitEditResident (row) {
      let isInvalid = false
      this.$refs[`form${row.formId}`].forEach(el => {
        el.validate((valid) => {
          if (!valid) {
            isInvalid = true
          }
        })
      })
      if (isInvalid) {
        this.$message.error('請正確填寫住戶資料')
        return
      }
      if (row.Id) {
        try {
          const req = this.presentResidentDataToReqResidentData(row)
          await apiHousehold.putResident(this.tabletId, row.Id, req)
          this.$message({
            type: 'success',
            message: '編輯成功'
          })
          row.isEditing = false
        } catch (error) {
          this.$message({
            type: 'error',
            message: '編輯失敗'
          })
        }
      } else {
        try {
          const req = this.presentResidentDataToReqResidentData(row)
          const res = await apiHousehold.postResident(this.tabletId, req)
          row.Id = res.data.Data.Resident.Id
          this.$message({
            type: 'success',
            message: '新增成功'
          })
          row.isEditing = false
          this.isAddingResident = false
        } catch (error) {
          this.$message({
            type: 'error',
            message: '新增失敗'
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.property {
  @include mainLayer();
  .main{
    display: flex;
    flex-direction: column;
    gap:25px;
    .title_bar{
      margin:0;
    }
    .title_bar.center{
    margin: 0;
  }
    .function {
      display: flex;
      width: 100%;
      .left, .right{
        display: flex;
        flex: 0 0 50%;
        align-items: center;
      }
      .right{
        justify-content: flex-end;
      }
    }
  }
  ::v-deep .el-table {
    @include basicTable();
    .el-form-item.is-error{
      margin-bottom: 55px;
    }
    .cell.redStar{
      @include redStar(0)
    }
  }

}
</style>
